import BaseController from "controllers/base_controller"

export default class extends BaseController {
  initialize () { }

  connect () { }
  disconnect () { }
}
